import React, { Fragment, useState } from "react";
import { Box, Button, CircularProgress, Stack, Typography } from "@mui/material";
import { GenericCircleIcon } from "../../../generic/GenericCircleIcon";
import { NeedHelp } from "../generic/GenericDialogFooter";
import { useTheme } from "@emotion/react";
import { WarningCircle } from "@phosphor-icons/react";
import { resendEmail } from "../../../../config/apisauce";
import { SIGN_IN_FORMS } from "../../../../enums/signInFormEnums";

export const AccountExists = ({ email, handleNextForm, handleCancel }) => {
  const [isLoading, setIsLoading] = useState(false);
  const theme = useTheme();

  const resend = async () => {
    setIsLoading(true);
    const response = await resendEmail({ email: email });
    if (response.ok) {
      handleNextForm({
        ...SIGN_IN_FORMS[2],
        data: {
          email: email,
        }
      });
    }
    setIsLoading(false);
  };

  return (
    <Fragment>
      <Box display={'flex'} justifyContent={'center'} alignItems={'center'} mb={2}>
        <GenericCircleIcon>
          <WarningCircle size={96} weight="thin" color={theme.palette.primary.main} />
        </GenericCircleIcon>
      </Box>
      <Stack gap={3} alignItems={'center'}>
        <Typography fontSize={'16px'} textAlign={'center'}>
          An account with this email already exists but hasn’t been verified. Would you like us to resend the verification email?
        </Typography>
        <Stack direction={{ xs: 'column', md: 'row' }} gap={1} alignItems={'center'} justifyContent={'center'} width={'100%'}>
          <Button variant="outlined" sx={{ width: { xs: '100%', sm: '250px' } }} fullWidth onClick={() => handleCancel()}>Cancel</Button>
          <Button variant="contained" sx={{ color: "#FFF", width: { xs: '100%', sm: '250px' } }} fullWidth onClick={() => resend()} endIcon={isLoading && <CircularProgress size={14} color="inherit" />} disabled={isLoading}>Resend Verification Email</Button>
        </Stack>
        <NeedHelp />
      </Stack>
    </Fragment>
  )
} 